import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

export interface props {
  items: ReactNode[];
}

export const NumberedList: React.FC<props> = (props) => {
  const items = props.items.filter((x) => !!x);

  if (items.length === 0) {
    return null;
  }

  return (
    <div>
      {items.map((x, i) => (
        <P2GGrid key={i} container alignContent="center" alignItems="center" gap={1} wrap="nowrap">
          <P2GGrid item flexShrink={1}>
            <P2GText variant="h3" component="span">
              {i + 1}.
            </P2GText>
          </P2GGrid>
          <P2GGrid item flexGrow={1}>
            {x}
          </P2GGrid>
        </P2GGrid>
      ))}
    </div>
  );
};
